import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable()
export class ConfigService {
  private appConfig: any;

  constructor(private http: HttpClient) { }

  public async loadAppConfig(): Promise<void> {
    const url = environment.appConfigPath;
    const data = await firstValueFrom(this.http.get(url));
    this.appConfig = data;
  }

  public getConfig(): any {
    return this.appConfig;
  }
}
